let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eHPNt")).then(() => parcelRequire('aARrG'));